var NOTIF_FROM = "SPACE Notifications";
var NOTIF_AVATAR = "img/space-avatar.png";
var NOTIF_LOCK_ICON = "img/wa-lock-icon.png";
var NOTIF_PHOTO_KEY = "img/safe-interior-key.jpg";
var NOTIF_PHOTO_KEY_VIDEO = "img/safe-interior-key-video.png";
var NOTIF_PHOTO_CHECKOUT = "img/safe-interior-checkout.jpg";
var NOTIF_PORTAL_PAGE = "portal-capsule.html?v=53";
var NOTIF_LOCK_WALL = "img/lock-beach.jpg";
var NOTIF_TIME = "11:30";
var NOTIF_CARRIER = "VZW Wi-Fi";

var NOTIF_STEPS = [
  { key:"setup",    label:"Setup",     time:"11:27", tone:"brand",
    title:"Setup your safe",
    body:"Your code <b>5857</b> is for safe: <b>Room 212</b>. This enables notifications during your stay.",
    sub:"This code will be active for 5 minutes." },
  { key:"pin",      label:"Wrong PIN", time:"11:31", tone:"warn",
    title:"Security Alert - Room 212",
    body:"An incorrect PIN was entered.",
    sub:"If this was not you, please go back to the safe to check on your possessions." },
  { key:"forgot",   label:"Forgot PIN", time:"11:33", tone:"brand",
    body:"Forgot PIN has been pressed. Your PIN to access <b>Room 212</b> is <b>1971</b>." },
  { key:"open",     label:"Opened",    time:"11:33", tone:"ok",
    body:"Your safe <b>Room 212</b> was opened.",
    sub:"If this wasn't you, please contact the property." },
  { key:"door",     label:"Left Open", time:"11:34", tone:"warn",
    title:"Door Left Open - Room 212",
    body:"You didn't close your safe.",
    sub:"Go back and lock it so nothing is left exposed." },
  { key:"key",      label:"Staff key", time:"11:35", tone:"alert",
    body:"<b>Room 212</b> was opened with a key 🔑. Here is a complete recording of your safe from opening through relocking.",
    sub:"Contact the police or the hotel if something went missing.", photo:"inside" },
  { key:"checkout", label:"End of Stay", time:"11:38", tone:"ok",
    body:"Thanks for staying! Here is an image of the inside of <b>Room 212</b> after your access was removed.",
    sub:"Contact the property if you left something in the safe.", photo:"checkout" },
  { key:"summary",  label:"Summary",   time:"19:38", tone:"brand",
    title:"Your Room 212 Space Capsule",
    body:"View at: <b>p.sp.toys/s/jXkgVxSC</b> for a full record of your stay.",
    sub:"Viewable for 30 days", portal:true }
];

var NOTIF_NARR = [
  { p:"An OTP to verify your phone number so you can receive notifications." },
  { p:"Get notified if an incorrect PIN was entered, whether it was you or not." },
  { p:"Forgot your PIN? Push the button on the screen to get a new PIN." },
  { p:"If you didn't open the safe, you'll sure appreciate this message." },
  { p:"If you accidentally forgot to lock the safe, you'll get notified." },
  { p:"Know if someone tries to access the safe without you present. And if opened, receive a notification with a photo of your contents." },
  { p:"When the stay ends, the safe sends a photo of the empty interior, so nothing gets left behind." },
  { p:"8 hours after your stay, you'll get a full report." },
  { p:"Every activity and image stored for your viewing for up to 30 days." }
];
var NOTIF_PORTAL_LABEL = "Portal";

function _ntStatusIcons(){
  return '<svg class="nt-sb-ic" width="70" height="12" viewBox="0 0 70 12" fill="currentColor" aria-hidden="true">'
    + '<rect x="0" y="7" width="3" height="5" rx="1"/><rect x="5" y="5" width="3" height="7" rx="1"/><rect x="10" y="3" width="3" height="9" rx="1"/><rect x="15" y="1" width="3" height="11" rx="1"/>'
    + '<path d="M26 4.2c3.4-3.1 8.6-3.1 12 0l-1.5 1.6c-2.5-2.3-6.5-2.3-9 0zM28.6 6.9c2-1.7 4.8-1.7 6.8 0l-1.5 1.6c-1.1-1-2.7-1-3.8 0z"/><circle cx="32" cy="10.4" r="1.4"/>'
    + '<rect x="52" y="2" width="15" height="9" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.1" opacity=".5"/><rect x="53.5" y="3.5" width="10" height="6" rx="1.4"/><rect x="68" y="4.6" width="1.6" height="3.8" rx=".8" opacity=".5"/>'
    + '</svg>';
}
function _ntStatusBar(leftHtml){
  return '<div class="nt-sb"><span class="nt-sb-left">'+leftHtml+'</span><span class="nt-sb-ics">'+_ntStatusIcons()+'</span></div>';
}
function _ntWaBadge(){
  return '<svg class="nt-wabadge" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#25D366"/><path fill="#fff" d="M12 5.2a6.8 6.8 0 00-5.8 10.3L5.2 19l3.6-1a6.8 6.8 0 103.2-12.8zm3.7 9.4c-.2.5-.9.9-1.3 1-.4 0-.8.2-2.8-.6-2.3-1-3.8-3.3-4-3.5-.1-.2-1-1.3-1-2.4 0-1.2.6-1.7.8-1.9.2-.2.4-.3.5-.3h.4c.1 0 .3 0 .4.3l.6 1.5c0 .1.1.2 0 .4l-.3.3-.3.3c-.1.1-.2.2-.1.4.1.2.6.9 1.2 1.5.9.7 1.5.9 1.7 1 .2.1.3.1.4 0l.6-.7c.2-.2.3-.1.5-.1l1.4.7c.2.1.3.2.4.2 0 .2 0 .5-.2 1z"/></svg>';
}
function _ntAppIcon(){
  return '<span class="nt-appicon nt-appicon-lock"><img class="nt-appicon-lk" src="'+NOTIF_LOCK_ICON+'" alt=""></span>';
}
function _ntPhoto(kind){
  var src = (kind === "checkout") ? NOTIF_PHOTO_CHECKOUT : NOTIF_PHOTO_KEY;
  var camIcon = '<svg class="nt-vid-cam" width="11.5" height="11.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
    + '<rect x="1.5" y="6" width="13" height="12" rx="2.6"/><path d="M16.2 11 23 6.6v10.8L16.2 13Z"/></svg>';
  var vid = (kind === "checkout") ? '' :
    '<span class="nt-vid-play" aria-hidden="true"></span><span class="nt-vid-dur" aria-hidden="true">'+camIcon+'0:13</span>';
  if (kind === "checkout") {
    return '<div class="nt-photo"><img src="'+src+'" alt="Interior camera view inside the safe"></div>';
  }
  return '<div class="nt-photo nt-photo-vid">'
    + '<img class="nt-ph-still" src="'+NOTIF_PHOTO_KEY+'" alt="Interior camera view inside the safe">'
    + '<img class="nt-ph-vid" src="'+NOTIF_PHOTO_KEY_VIDEO+'" alt="Recording of the inside of the safe during key access">'
    + vid + '</div>';
}

function _ntToMin(t){ var p = t.split(":"); return (+p[0])*60 + (+p[1]); }
function _ntFmt12(t, ampm){
  var p = t.split(":"), h = +p[0], m = p[1];
  var ap = (h >= 12) ? "PM" : "AM", h12 = h % 12; if (h12 === 0) h12 = 12;
  return h12 + ":" + m + (ampm ? (" " + ap) : "");
}

function _ntItem(step, i, mode){
  var photo  = step.photo ? _ntPhoto(step.photo) : '';
  var title  = step.title ? '<div class="nt-item-title">'+step.title+'</div>' : '';
  var sub    = step.sub   ? '<div class="nt-item-sub">'+step.sub+'</div>' : '';
  var portal = step.portal ? '<button type="button" class="nt-portalbtn" data-nt-portal>Open the secure portal</button>' : '';
  if (mode === "wa"){
    return '<div class="nt-item nt-wa-item nt-tone-'+step.tone+'" data-nt-item data-i="'+i+'" data-key="'+step.key+'">'
      + photo + title + '<div class="nt-item-body">'+step.body+'</div>' + sub + portal
      + '<span class="nt-item-time">'+_ntFmt12(step.time, true)+'</span></div>';
  }
  return '<div class="nt-item nt-lk-item nt-tone-'+step.tone+(step.photo?' nt-has-photo':'')+'" data-nt-item data-i="'+i+'" data-min="'+_ntToMin(step.time)+'">'
    + _ntAppIcon()
    + '<div class="nt-lk-tx"><div class="nt-item-hd"><span class="nt-item-from">'+NOTIF_FROM+'</span><span class="nt-item-time nt-lk-when"></span></div>'
    + '<div class="nt-item-body">'+step.body+'</div></div>'
    + photo
    + '</div>';
}

function _ntLockView(){
  var items = '';
  for (var i=0;i<NOTIF_STEPS.length;i++) items += _ntItem(NOTIF_STEPS[i], i, "lock");
  var grouphd = '<div class="nt-lk-grouphd" data-nt-grouphd><span class="nt-lk-gh-app">WhatsApp</span>'
    + '<span class="nt-lk-gh-actions"><span class="nt-lk-gh-less"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 9l6 6 6-6"/></svg>Show less</span><span class="nt-lk-gh-x">&times;</span></span></div>';
  return '<div class="nt-view nt-view-lock">'
    + _ntStatusBar('<span class="nt-sb-carrier">'+NOTIF_CARRIER+'</span>')
    + '<div class="nt-lk-clock"><div class="nt-lk-date">Thursday, July 9</div><div class="nt-lk-time">'+NOTIF_TIME+'</div></div>'
    + '<div class="nt-feed nt-feed-lock">'+grouphd+items+'</div>'
    + '</div>';
}
function _ntWaView(){
  var items = '';
  for (var i=0;i<NOTIF_STEPS.length;i++) items += _ntItem(NOTIF_STEPS[i], i, "wa");
  var head = '<div class="nt-wa-hd"><span class="nt-wa-back">‹</span>'
    + '<img class="nt-wa-av" src="'+NOTIF_AVATAR+'" alt="">'
    + '<div class="nt-wa-nm"><span class="nt-wa-name">'+NOTIF_FROM+'</span><span class="nt-wa-info">tap for contact info</span></div>'
    + '</div>';
  var pre = '<div class="nt-wa-day">Today</div><div class="nt-wa-enc">&#128274; Messages and calls are end-to-end encrypted. Only people in this chat can read, listen to, or share them.</div>';
  return '<div class="nt-view nt-view-wa">'
    + _ntStatusBar('<span class="nt-sb-time">'+NOTIF_TIME+'</span>') + head
    + '<div class="nt-feed nt-feed-wa">'+pre+items+'</div>'
    + '</div>';
}
function _ntPortalView(){
  var lock = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7.5a4 4 0 0 1 8 0V11"/></svg>';
  return '<div class="nt-view nt-view-portal">'
    + _ntStatusBar('<span class="nt-sb-time">'+NOTIF_TIME+'</span>')
    + '<div class="nt-pv-bar">'+lock+'<span class="nt-pv-url">portal.thespacesafe.com</span></div>'
    + '<div class="nt-pv-scroll"><iframe class="nt-pv-frame" data-nt-pvframe src="'+NOTIF_PORTAL_PAGE+'" title="Your Space Capsule" loading="lazy" scrolling="no"></iframe><div class="nt-pv-catch"></div></div>'
    + '</div>';
}
function _ntPhone(){
  return '<div class="nt-phone" data-nt-phonewrap>'
    + '<span class="nt-btn nt-btn-act"></span><span class="nt-btn nt-btn-vu"></span>'
    + '<span class="nt-btn nt-btn-vd"></span><span class="nt-btn nt-btn-pw"></span>'
    + '<div class="nt-island"></div>'
    + '<div class="nt-screen">'+_ntLockView()+_ntWaView()+_ntPortalView()+'</div></div>';
}

function _ntViewToggle(){
  var lock = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M7.5 10.5V7a4.5 4.5 0 0 1 9 0v3.5"/></svg>';
  var wa = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 00-8.5 15.3L2 22l4.8-1.5A10 10 0 1012 2zm5.5 14.2c-.3.7-1.4 1.3-1.9 1.4-.5.1-1.2.1-4-1-2.9-1.2-4.7-4.1-4.9-4.3-.1-.2-1.1-1.5-1.1-2.9s.7-2.1 1-2.4c.3-.3.6-.4.8-.4h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.4.5-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.2.4-.2.6-.1l2 .9c.2.1.4.2.4.3.1.2.1.8-.2 1.5z"/></svg>';
  return '<div class="nt-vtog" data-nt-vtog role="tablist" aria-label="Phone view">'
    + '<button type="button" class="nt-vtog-btn is-active" data-nt-view-btn="lock" title="Lock screen">'+lock+'<span>Lock</span></button>'
    + '<button type="button" class="nt-vtog-btn nt-vtog-wa" data-nt-view-btn="wa" title="WhatsApp">'+wa+'<span>WhatsApp</span></button>'
    + '</div>';
}

function _ntStepper(c){
  if (c.stepper === "none") return '';
  var s = '';
  for (var i=0;i<NOTIF_STEPS.length;i++){
    s += '<button type="button" class="nt-step" data-nt-step data-i="'+i+'"><span class="nt-step-dot"></span><span class="nt-step-lab">'+NOTIF_STEPS[i].label+'</span></button>';
  }
  s += '<button type="button" class="nt-step nt-step-portal" data-nt-step data-i="'+NOTIF_STEPS.length+'"><span class="nt-step-dot"></span><span class="nt-step-lab">'+NOTIF_PORTAL_LABEL+'</span></button>';
  return '<div class="nt-steps nt-steps-across nt-steps-'+(c.steppos||"top")+'" role="tablist">'+s+'</div>';
}
var NOTIF_HEAD = "Guest notifications";
function _ntNarr(){
  var s = '';
  for (var j=0;j<NOTIF_NARR.length;j++){
    s += '<div class="nt-narr-item" data-nt-narr data-i="'+j+'"><p class="nt-narr-p">'+NOTIF_NARR[j].p+'</p></div>';
  }
  return '<div class="nt-narr">'+s+'</div>';
}
function _ntHead(){ return '<div class="nt-tophead"><h2 class="nt-tophead-h">'+NOTIF_HEAD+'</h2></div>'; }

function notifRender(n){
  var c = notifCfg(n);
  var phone = _ntPhone(), narr = _ntNarr(), toggle = _ntViewToggle(), stepper = _ntStepper(c), head = _ntHead();
  var narrCol  = '<div class="nt-col nt-col-narr">'+head+narr+stepper+'</div>';
  var phoneCol = '<div class="nt-col nt-col-phone">'+phone+'</div>';
  var togCol   = '<div class="nt-col nt-col-tog">'+toggle+'</div>';
  var row;
  if (c.layout === "center"){
    row = '<div class="nt-stack">'+head+narr+stepper+'<div class="nt-stack-row">'+togCol+phoneCol+'</div></div>';
  } else if (c.layout === "left"){
    row = phoneCol + togCol + narrCol;
  } else {
    row = narrCol + togCol + phoneCol;
  }
  var stage = '<div class="nt-stage">'+row+'</div>';
  return '<div class="nt nt-'+n+' nt-lay-'+c.layout+'" id="nt-'+n+'" data-view="lock" data-motion="'+(c.motion||'auto')+'" data-reveal="'+(c.reveal||'stack')+'">'
    + '<div class="nt-inner">' + stage + '</div>'
    + '</div>';
}

var NT_STEP_DWELL = 2800, NT_PORTAL_DWELL = 18000, NT_PORTAL_SCROLL = 16000;
function _ntFit(root, grouphd, lkByIdx, refIdx){
  var feedEl = root.querySelector(".nt-feed-lock");
  if (!feedEl || refIdx < 0) return;
  var cs = getComputedStyle(feedEl);
  var gap = parseFloat(cs.rowGap || cs.gap) || 9;
  var avail = feedEl.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
  if (grouphd && grouphd.style.display !== "none") avail -= (grouphd.offsetHeight + gap);
  var used = 0, over = false;
  for (var d = 0; d <= refIdx; d++){
    var el = lkByIdx[refIdx - d];
    if (!el) continue;
    if (over){ el.style.display = "none"; continue; }
    el.style.display = "";
    var add = el.offsetHeight + (used > 0 ? gap : 0);
    if (used + add > avail && d > 0){ el.style.display = "none"; over = true; }
    else used += add;
  }
}
function _ntFitWa(root){
  var feed = root.querySelector(".nt-feed-wa");
  if (!feed || feed.clientHeight < 10) return;
  var pre = feed.querySelectorAll(".nt-wa-day, .nt-wa-enc");
  var all = feed.querySelectorAll(".nt-wa-item");
  var shown = [], i;
  for (i=0;i<all.length;i++){ var on = all[i].classList.contains("is-shown");
    all[i].style.display = on ? "" : "none"; if (on) shown.push(all[i]); }
  for (i=0;i<pre.length;i++) pre[i].style.display = "";
  feed.style.justifyContent = "flex-start";
  feed.scrollTop = 0;
  if (feed.scrollHeight <= feed.clientHeight + 1) return;
  feed.style.justifyContent = "flex-end";
  for (i=0;i<pre.length;i++) pre[i].style.display = "none";
  var cs = getComputedStyle(feed);
  var gap = parseFloat(cs.rowGap || cs.gap) || 8;
  var avail = feed.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
  var used = 0, over = false;
  for (i = shown.length - 1; i >= 0; i--){
    if (over){ shown[i].style.display = "none"; continue; }
    var add = shown[i].offsetHeight + (used > 0 ? gap : 0);
    if (used + add > avail && i < shown.length - 1){ shown[i].style.display = "none"; over = true; }
    else used += add;
  }
}
function _ntInit(root){
  if (root.getAttribute("data-nt-ready")) return;
  root.setAttribute("data-nt-ready","1");
  var motion = root.getAttribute("data-motion") || "auto";
  var reveal = root.getAttribute("data-reveal") || "stack";
  var items = root.querySelectorAll("[data-nt-item]");
  var lkItems = root.querySelectorAll(".nt-lk-item[data-nt-item]");
  var narrs = root.querySelectorAll("[data-nt-narr]");
  var steps = root.querySelectorAll("[data-nt-step]");
  var vbtns = root.querySelectorAll("[data-nt-view-btn]");
  var pvFrame = root.querySelector("[data-nt-pvframe]");
  var grouphd = root.querySelector("[data-nt-grouphd]");
  var stepMins = []; for (var m=0;m<NOTIF_STEPS.length;m++) stepMins.push(_ntToMin(NOTIF_STEPS[m].time));
  var portalIdx = NOTIF_STEPS.length;
  var n = NOTIF_STEPS.length + 1;
  var cur = -1, timer = null, paused = false, userView = root.getAttribute("data-view") || "lock";
  function sizePortal(){ if (!pvFrame) return; var box = pvFrame.parentNode, w = box.clientWidth, h = box.clientHeight;
    if (w < 10) return; var iw = 390, s = w / iw;
    pvFrame.style.width = iw + "px"; pvFrame.style.height = (h / s) + "px"; pvFrame.style.transform = "scale(" + s + ")"; }
  var coarsePtr = !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
  function scrollPortal(active){
    if (!pvFrame) return;
    if (active) sizePortal();
    if (!pvFrame.contentWindow) return;
    try {
      pvFrame.contentWindow.postMessage("nt-reset", "*");
      if (active && coarsePtr) pvFrame.contentWindow.postMessage("nt-scroll", "*");
    } catch(e){}
  }
  function paint(){
    var k, idx, portal = (cur === portalIdx);
    root.setAttribute("data-view", portal ? "portal" : userView);
    for (k=0;k<items.length;k++){ idx = +items[k].getAttribute("data-i");
      items[k].classList.toggle("is-shown", reveal === "replace" ? (idx === cur) : (idx <= cur));
      items[k].classList.toggle("is-active", idx === cur); }
    for (k=0;k<items.length;k++){ if (+items[k].getAttribute("data-i") === cur && items[k].classList.contains("is-shown")){
      var _el = items[k]; _el.style.animation = "none"; void _el.offsetWidth; _el.style.animation = ""; } }
    var refIdx = (cur >= portalIdx) ? (portalIdx - 1) : cur;
    var refMin = (refIdx >= 0) ? stepMins[refIdx] : 0;
    var clockStr = _ntFmt12((refIdx >= 0) ? NOTIF_STEPS[refIdx].time : NOTIF_TIME, false);
    var lkTime = root.querySelector(".nt-lk-time"); if (lkTime) lkTime.textContent = clockStr;
    var sbTimes = root.querySelectorAll(".nt-sb-time"); for (k=0;k<sbTimes.length;k++) sbTimes[k].textContent = clockStr;
    var lkByIdx = {};
    for (k=0;k<lkItems.length;k++){ idx = +lkItems[k].getAttribute("data-i");
      lkByIdx[idx] = lkItems[k];
      lkItems[k].style.order = String(-idx);
      lkItems[k].style.display = (idx <= refIdx) ? "" : "none";
      var when = lkItems[k].querySelector(".nt-lk-when");
      if (when){ var d = refMin - stepMins[idx]; when.textContent = (d <= 0) ? "now" : (d < 60 ? (d + "m ago") : (Math.floor(d/60) + "h ago")); }
    }
    if (grouphd) grouphd.style.display = (refIdx >= 1) ? "flex" : "none";
    _ntFit(root, grouphd, lkByIdx, refIdx);
    _ntFitWa(root);
    for (k=0;k<narrs.length;k++){ narrs[k].classList.toggle("is-active", +narrs[k].getAttribute("data-i") === cur); }
    for (k=0;k<steps.length;k++){ steps[k].classList.toggle("is-active", +steps[k].getAttribute("data-i") === cur); }
    for (k=0;k<vbtns.length;k++){ vbtns[k].classList.toggle("is-active", !portal && vbtns[k].getAttribute("data-nt-view-btn") === userView); }
    scrollPortal(portal);
  }
  function stop(){ if (timer){ clearTimeout(timer); timer = null; } }
  function schedule(){ stop(); if (motion !== "auto") return;
    timer = setTimeout(function tick(){ if (paused){ timer = setTimeout(tick, 400); return; } next(); }, (cur === portalIdx) ? NT_PORTAL_DWELL : NT_STEP_DWELL); }
  function go(i){ cur = (i + n) % n; paint(); schedule(); }
  function next(){ go(cur + 1); }
  var s;
  for (s=0;s<steps.length;s++){ (function(idx){ steps[idx].addEventListener("click", function(){ go(idx); }); })(s); }
  for (s=0;s<vbtns.length;s++){ (function(btn){ btn.addEventListener("click", function(){
      userView = btn.getAttribute("data-nt-view-btn");
      if (cur === portalIdx) cur = portalIdx - 1;
      go(cur);
    }); })(vbtns[s]); }
  var waBack = root.querySelectorAll(".nt-wa-back");
  for (s=0;s<waBack.length;s++){ waBack[s].addEventListener("click", function(){
      userView = "lock";
      if (cur === portalIdx) cur = portalIdx - 1;
      go(cur);
    }); }
  var nextBtn = root.querySelector("[data-nt-next]");
  if (nextBtn) nextBtn.addEventListener("click", next);
  root.addEventListener("mouseenter", function(){ paused = true; });
  root.addEventListener("mouseleave", function(){ paused = false; });
  var _touchIdle = null;
  function _touchResumeSoon(){
    if (_touchIdle) clearTimeout(_touchIdle);
    _touchIdle = setTimeout(function(){ paused = false; _touchIdle = null; }, 4000);
  }
  root.addEventListener("touchstart", function(){
    paused = true;
    if (_touchIdle) { clearTimeout(_touchIdle); _touchIdle = null; }
  }, { passive: true });
  root.addEventListener("touchend", _touchResumeSoon, { passive: true });
  root.addEventListener("touchcancel", _touchResumeSoon, { passive: true });
  var openers = root.querySelectorAll("[data-nt-portal]");
  for (var o=0;o<openers.length;o++) openers[o].addEventListener("click", function(e){ e.stopPropagation(); go(portalIdx); });
  for (var lc=0;lc<lkItems.length;lc++) lkItems[lc].addEventListener("click", function(){ userView = "wa"; if (cur === portalIdx) cur = portalIdx - 1; go(cur); });
  if (pvFrame) pvFrame.addEventListener("load", function(){ if (cur === portalIdx) scrollPortal(true); });
  var keyBubbles = root.querySelectorAll('.nt-wa-item[data-key="key"]');
  function _ntGoKeySection(){
    var t = document.getElementById("camera-proof");
    if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  for (var kb=0; kb<keyBubbles.length; kb++){
    var kbEl = keyBubbles[kb];
    kbEl.classList.add("nt-wa-linked");
    kbEl.setAttribute("role", "button");
    kbEl.setAttribute("tabindex", "0");
    kbEl.setAttribute("title", "See the full key access recording");
    kbEl.addEventListener("click", function(e){ e.stopPropagation(); _ntGoKeySection(); });
    kbEl.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); _ntGoKeySection(); } });
  }
  var waImgs = root.querySelectorAll(".nt-wa-item img");
  for (var wj=0; wj<waImgs.length; wj++) waImgs[wj].addEventListener("load", function(){ _ntFitWa(root); });

  function scrollDriven(){
    var phone = root.querySelector(".nt-phone");
    if (!phone) return;
    var acc = 0, THRESH = 90, pAtBottom = false, pAtTop = true;
    window.addEventListener("message", function(e){ var d = e.data;
      if (d && typeof d === "object" && d.nt === "pos"){ pAtBottom = !!d.atBottom; pAtTop = !!d.atTop; } });
    phone.addEventListener("wheel", function(e){
      var dir = e.deltaY > 0 ? 1 : -1;
      if (cur === portalIdx){
        if (dir > 0 && pAtBottom){ acc = 0; return; }
        if (dir < 0 && pAtTop){ e.preventDefault(); acc += e.deltaY; if (acc <= -THRESH){ acc = 0; go(portalIdx-1); } return; }
        e.preventDefault();
        if (pvFrame && pvFrame.contentWindow) pvFrame.contentWindow.postMessage({nt:"by", dy: e.deltaY}, "*");
        return;
      }
      if (cur <= 0 && dir < 0){ acc = 0; return; }
      e.preventDefault();
      acc += e.deltaY;
      if (acc >= THRESH){ acc = 0; go(cur + 1); }
      else if (acc <= -THRESH){ acc = 0; go(cur - 1); }
    }, {passive:false});
  }
  function portalWheel(){
    if (!pvFrame) return;
    var pAtBottom = false, pAtTop = true;
    window.addEventListener("message", function(e){ var d = e.data;
      if (d && typeof d === "object" && d.nt === "pos"){ pAtBottom = !!d.atBottom; pAtTop = !!d.atTop; } });
    function onWheel(e){
      if (cur !== portalIdx) return;
      var dir = e.deltaY > 0 ? 1 : -1;
      if (dir > 0 && pAtBottom) return;
      if (dir < 0 && pAtTop) return;
      e.preventDefault();
      try { pvFrame.contentWindow.postMessage({nt:"by", dy: e.deltaY}, "*"); } catch(err){}
    }
    var catcher = root.querySelector(".nt-pv-catch");
    function reachableDoc(){ try { return pvFrame.contentDocument || null; } catch(err){ return null; } }
    function attach(){
      var d = reachableDoc();
      if (d){
        d.removeEventListener("wheel", onWheel, {passive:false});
        d.addEventListener("wheel", onWheel, {passive:false});
        if (catcher) catcher.style.pointerEvents = "none";
      } else if (catcher){
        catcher.style.pointerEvents = "auto";
        catcher.removeEventListener("wheel", onWheel, {passive:false});
        catcher.addEventListener("wheel", onWheel, {passive:false});
      }
    }
    pvFrame.addEventListener("load", attach);
    attach(); setTimeout(attach, 400); setTimeout(attach, 1200);
  }
  function portalTouch(){
    if (!pvFrame) return;
    var lastY = null, idleTimer = null, IDLE = 4000, pAtBottom = false, pAtTop = true;
    window.addEventListener("message", function(e){ var d = e.data;
      if (d && typeof d === "object" && d.nt === "pos"){ pAtBottom = !!d.atBottom; pAtTop = !!d.atTop; } });
    function clearIdle(){ if (idleTimer){ clearTimeout(idleTimer); idleTimer = null; } }
    function resumeSoon(){ clearIdle(); idleTimer = setTimeout(function(){
      if (cur !== portalIdx) return;
      paused = false;
      try { if (pvFrame.contentWindow) pvFrame.contentWindow.postMessage("nt-scroll", "*"); } catch(err){}
      stop(); schedule();
    }, IDLE); }
    function onStart(e){ if (cur !== portalIdx) return;
      paused = true; clearIdle();
      lastY = (e.touches && e.touches[0]) ? e.touches[0].clientY : null;
      try { pvFrame.contentWindow.postMessage({nt:"by", dy:0}, "*"); } catch(err){} }
    function onMove(e){ if (cur !== portalIdx || lastY === null || !e.touches || !e.touches[0]) return;
      var y = e.touches[0].clientY, dy = lastY - y; lastY = y;
      if ((dy > 0 && pAtBottom) || (dy < 0 && pAtTop)) return;
      e.preventDefault();
      try { pvFrame.contentWindow.postMessage({nt:"by", dy: dy}, "*"); } catch(err){} }
    function onEnd(){ if (cur !== portalIdx) return; lastY = null; resumeSoon(); }
    var catcher = root.querySelector(".nt-pv-catch");
    function reachableDoc(){ try { return pvFrame.contentDocument || null; } catch(err){ return null; } }
    function attach(){
      var d = reachableDoc(), t = d || catcher;
      if (!t) return;
      if (!d && catcher) catcher.style.pointerEvents = "auto";
      t.removeEventListener("touchstart", onStart, {passive:false}); t.addEventListener("touchstart", onStart, {passive:false});
      t.removeEventListener("touchmove", onMove, {passive:false}); t.addEventListener("touchmove", onMove, {passive:false});
      t.removeEventListener("touchend", onEnd); t.addEventListener("touchend", onEnd);
    }
    pvFrame.addEventListener("load", attach);
    attach(); setTimeout(attach, 400); setTimeout(attach, 1200);
  }
  if (motion === "scroll"){
    var fine = !(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    if (fine) scrollDriven(); else { motion = "auto"; portalWheel(); }
  } else {
    portalWheel();
  }
  portalTouch();

  paint();
  var _started = false;
  function _begin(){ if (_started) return; _started = true; setTimeout(function(){ go(0); }, 120); }
  if (window.IntersectionObserver){
    var _io = new IntersectionObserver(function(ents){
      for (var _e=0;_e<ents.length;_e++){ if (ents[_e].isIntersecting){ _begin(); _io.disconnect(); break; } }
    }, { threshold: 0.3 });
    _io.observe(root);
  } else {
    setTimeout(_begin, 520);
  }
}
function notifInitAll(){ var all = document.querySelectorAll(".nt"); for (var i=0;i<all.length;i++) _ntInit(all[i]); }

var NOTIF_CONFIGS = [
  {n:1, label:"Phone right, steps across the top (auto-advances)", layout:"right", steppos:"top", motion:"auto", reveal:"stack"},
  {n:2, label:"Phone left, steps across the top",      layout:"left",   steppos:"top",    motion:"auto",  reveal:"stack"},
  {n:3, label:"Centered, steps across the top",        layout:"center", steppos:"top",    motion:"auto",  reveal:"stack"},
  {n:4, label:"Phone right, steps across the bottom",  layout:"right",  steppos:"bottom", motion:"auto",  reveal:"stack"},
  {n:5, label:"Centered, steps across the bottom",     layout:"center", steppos:"bottom", motion:"auto",  reveal:"stack"},
  {n:6, label:"Phone right, click to advance",         layout:"right",  steppos:"top",    motion:"click", reveal:"stack"}
];
var NOTIF_GROUPS = [
  {t:"Layouts (Lock / WhatsApp switch + Portal finale)", s:"steps run across; default view is the lock screen, tap WhatsApp to open the thread, the story ends by opening the real portal", ns:[1,2,3,4,5,6]}
];
function notifCfg(n){ for (var i=0;i<NOTIF_CONFIGS.length;i++){ if (NOTIF_CONFIGS[i].n === n) return NOTIF_CONFIGS[i]; } return NOTIF_CONFIGS[0]; }
function notifHTML(n){ return notifRender(n); }
